import React, { useState } from 'react';
import Button, { ButtonType } from '../../common/Button';
import { InnoButton } from '@innomotics/innomotics-build-react-lib';
import { joinApiUrl } from '../../../services';

const TestIpc = () => {
    const [jsonString, setJsonString] = useState('');

    const handleSubmit = async () => {
        try {
            const url = joinApiUrl(process.env.REACT_APP_BASE_URL, '/ConfigurationIpc');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: jsonString
            });

            // Keep the same browser session so the IPC payload stored by the POST
            // is available when the result page loads.
            window.location.assign(response.url);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
            <div className='test-page-container'>
                <div className='test-data-container'>
                    <div className='form-column'>
                        <div>
                        <label>Json data</label>
                        <br />
                        <br />
                        <textarea
                            style={{ width: '800px', height: '500px' }}
                                value={jsonString}
                                onChange={e => setJsonString(e.target.value)}
                                placeholder='Enter JSON string here'
                            />
                        <br />
                        </div>
                    </div>
                </div>
                <div className='form-submit'>
                    <InnoButton variant='primary' onClick={() => handleSubmit()}>
                            <div>POST</div>
                    </InnoButton>
                </div>
            </div>
    );
};

export default TestIpc;
